export const topicCommunityTabs = {
  overview: 'overview',
  thread: 'thread',
  initiatives: 'initiatives',
  knowledgeHub: 'knowledgeHub',
  contactInfo: 'contactInfo',
  events: 'events',
} as const

export const topicCommunityTabsQueryParamName = 'tab'
